"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._groupProbsByOutcomeIds = _groupProbsByOutcomeIds;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const findBestPair_1 = require("./findBestPair");
function _groupProbsByOutcomeIds(event, clientFilteredProbsMap) {
    var _a, _b;
    // Filter probabilities if a clientFilteredProbsMap is provided, otherwise use all event probabilities.
    /*
        clientFilteredProbsMap: { HANDICAP: [102, 105], TOTAL: [107, 109]}
      */
    const markets = clientFilteredProbsMap
        ? filterProbabilities(((_a = event.probabilities) === null || _a === void 0 ? void 0 : _a.markets) || [], clientFilteredProbsMap)
        : (_b = event.probabilities) === null || _b === void 0 ? void 0 : _b.markets;
    // Reduce the filtered probabilities to a map keyed by outcomeTypeId.
    const probabilitiesByOutcomeTypeId = markets === null || markets === void 0 ? void 0 : markets.reduce((acc, market) => {
        market.probabilities.forEach((probability) => {
            acc[probability.outcomeTypeId] = probability;
        });
        return acc;
    }, {});
    // Return the probabilities map or an empty object if no probabilities exist.
    return probabilitiesByOutcomeTypeId || {};
}
function filterProbabilities(eventProbabilitiesMarkets, clientFilteredProbsMap) {
    // для них надо искать пары
    const marketTypes = [
        betweb_openapi_axios_1.HotProbabilityMarketType.Handicap,
        betweb_openapi_axios_1.HotProbabilityMarketType.HandicapWithOt,
        betweb_openapi_axios_1.HotProbabilityMarketType.Total,
        betweb_openapi_axios_1.HotProbabilityMarketType.TotalWithOt,
    ];
    // Reduce the markets by filtering each one based on the provided market types.
    return marketTypes.reduce((filtered, marketType) => filterMarket(filtered, clientFilteredProbsMap, marketType), eventProbabilitiesMarkets);
}
function filterMarket(eventProbabilitiesMarkets, clientFilteredProbsMap, marketType) {
    const outcomeTypeIds = clientFilteredProbsMap[marketType];
    if (!outcomeTypeIds || outcomeTypeIds.length !== 2) {
        return eventProbabilitiesMarkets; // Expected two outcomeTypeIds
    }
    // Process each market to find and return the best pair of probabilities.
    return eventProbabilitiesMarkets.map((market) => processMarket(market, outcomeTypeIds, marketType));
}
function processMarket(market, outcomeTypeIds, marketType) {
    // Find matches for the provided outcomeTypeIds in the market's probabilities.
    const matches = outcomeTypeIds.map((id) => market.probabilities.filter((prob) => prob.outcomeTypeId === id));
    if (matches.flat().length !== market.probabilities.length) {
        return market; // All outcomeTypeIds must be present
    }
    // Find the best pair of probabilities based on the market type.
    const bestPair = (0, findBestPair_1.findBestPair)(matches[0], matches[1], marketType);
    return { ...market, probabilities: bestPair };
}
//# sourceMappingURL=_groupProbsByOutcomeIds.js.map